import { DetailsChildrenTab, DetailsSectionFiles, type DetailsPageProps } from 'app/main/components/page-layouts';

import ChronologyListItem from 'app/main/modules/chronology/ChronologyListItem';
import OpportunitiesListItem from 'app/main/modules/opportunities/OpportunitiesListItem';
import ContractsListItem from 'app/main/modules/contracts/ContractsListItem';
import OrdersListItem from 'app/main/modules/orders/OrdersListItem';
import ProjectsListItem from 'app/main/modules/projects/ProjectsListItem';
import ActivitiesListItem from 'app/main/modules/activities/ActivitiesListItem';

import MarketingActionsDetailsTab from './tabs/MarketingActionsDetailsTab';
import MarketingActionsRowsTab from './tabs/MarketingActionsRowsTab';

const tabs: DetailsPageProps['tabs'] = [
	{
		id: 'summary',
		title: 'TAB_SUMMARY',
		content: MarketingActionsDetailsTab
	},
	{
		id: 'companies',
		title: 'MODULE_COMPANIES_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ authorizer }) => authorizer.cannot('view', 'companies'),
		content: ({ model }) => <MarketingActionsRowsTab model={model} table="companies" />
	},
	{
		id: 'people',
		title: 'MODULE_PEOPLE_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ authorizer }) => authorizer.cannot('view', 'people'),
		content: ({ model }) => <MarketingActionsRowsTab model={model} table="people" />
	},
	{
		id: 'docs',
		title: 'MODULE_DOCS_NAME',
		disabled: ({ model, isEdit }) => isEdit || !model.maac_docs_folderpath,
		hidden: ({ authorizer, sysSettings }) =>
			sysSettings.docs_enabled !== 'true' ||
			sysSettings.docs_marketingactions_enabled !== 'true' ||
			authorizer.cannot('view', 'docs'),
		content: ({ model }) => (
			<DetailsSectionFiles folderPath={`${model.maac_docs_folderpath}\\${model.maac_docs_foldername}`} />
		)
	},
	{
		id: 'activities',
		title: 'MODULE_ACTIVITIES_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('activities') || authorizer.cannot('view', 'activities'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="activities"
				content={{ type: 'list', itemLayout: ActivitiesListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'acti_maac_uid', filt_clause: 'equals', filt_value: model.maac_uid }]}
			/>
		)
	},
	{
		id: 'opportunities',
		title: 'MODULE_OPPORTUNITIES_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('opportunities') || authorizer.cannot('view', 'opportunities'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="opportunities"
				content={{ type: 'list', itemLayout: OpportunitiesListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'oppo_maac_uid', filt_clause: 'equals', filt_value: model.maac_uid }]}
			/>
		)
	},
	{
		id: 'contracts',
		title: 'MODULE_CONTRACTS_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('contracts') || authorizer.cannot('view', 'contracts'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="contracts"
				content={{ type: 'list', itemLayout: ContractsListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'cntr_maac_uid', filt_clause: 'equals', filt_value: model.maac_uid }]}
			/>
		)
	},
	{
		id: 'orders',
		title: 'MODULE_ORDERS_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) => isModuleDisabled('orders') || authorizer.cannot('view', 'orders'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="orders"
				content={{ type: 'list', itemLayout: OrdersListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'ords_maac_uid', filt_clause: 'equals', filt_value: model.maac_uid }]}
			/>
		)
	},
	{
		id: 'projects',
		title: 'MODULE_PROJECTS_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('projects') || authorizer.cannot('view', 'projects'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="projects"
				content={{ type: 'list', itemLayout: ProjectsListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'proj_maac_uid', filt_clause: 'equals', filt_value: model.maac_uid }]}
			/>
		)
	},
	{
		id: 'chronology',
		title: 'MODULE_CHRONOLOGY_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('chronology') || authorizer.cannot('view', 'chronology'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="chronology"
				content={{ type: 'list', itemLayout: ChronologyListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'chro_maac_uid', filt_clause: 'equals', filt_value: model.maac_uid }]}
			/>
		)
	}
];

export default tabs;
